function CommentsIcon(props) {
  return (
    <svg
      version="1.1"
      id="Uploaded to svgrepo.com"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      {...props}
      xmlSpace="preserve">
      <path
        fill="currentColor"
        d="M16.5,20h7c0.276,0,0.5-0.224,0.5-0.5l0,0c0-0.276-0.224-0.5-0.5-0.5h-7c-0.276,0-0.5,0.224-0.5,0.5
	l0,0C16,19.776,16.224,20,16.5,20z M16.5,22h7c0.276,0,0.5-0.224,0.5-0.5l0,0c0-0.276-0.224-0.5-0.5-0.5h-7
	c-0.276,0-0.5,0.224-0.5,0.5l0,0C16,21.776,16.224,22,16.5,22z M15.5,7h-7C8.224,7,8,7.224,8,7.5v0C8,7.776,8.224,8,8.5,8h7
	C15.776,8,16,7.776,16,7.5v0C16,7.224,15.776,7,15.5,7z M15.5,9h-7C8.224,9,8,9.224,8,9.5v0C8,9.776,8.224,10,8.5,10h7
	c0.276,0,0.5-0.224,0.5-0.5v0C16,9.224,15.776,9,15.5,9z M15.5,11h-7C8.224,11,8,11.224,8,11.5v0C8,11.776,8.224,12,8.5,12h7
	c0.276,0,0.5-0.224,0.5-0.5v0C16,11.224,15.776,11,15.5,11z M22,12V5c0-1.657-1.343-3-3-3H5C3.343,2,2,3.343,2,5v9
	c0,1.657,1.343,3,3,3h4l1,1v6c0,1.657,1.343,3,3,3h4l2.293,2.293c0.391,0.391,1.024,0.391,1.414,0L23,27h4c1.657,0,3-1.343,3-3v-9
	c0-1.657-1.343-3-3-3H22z M9.414,16H5c-1.105,0-2-0.895-2-2V5c0-1.105,0.895-2,2-2h14c1.105,0,2,0.895,2,2v9c0,1.105-0.895,2-2,2
	h-4.414L12,18.586L9.414,16z M27,26h-4.414L20,28.586L17.414,26H13c-1.105,0-2-0.895-2-2v-5l0.293,0.293
	c0.391,0.391,1.024,0.391,1.414,0L15,17h4c1.657,0,3-1.343,3-3v-1h5c1.105,0,2,0.895,2,2v9C29,25.105,28.105,26,27,26z"
      />
    </svg>
  );
}

export default CommentsIcon;
